import React, { useEffect } from 'react'
import DealerBlock from '../DealerBlock/DealerBlock'
import '../MapContainer.scss'
import { useContext } from 'react'
import { dealersPerPageContext } from '../context'
import CONSTANTS from '../../../Constants'
const DealersList = ({ isLoading, showMoreDealers, isPCLCVFiltersActived }) => {
    const { dealersListPerPage } = useContext(dealersPerPageContext)
    const LoadingClass = (isLoading ? " Loading" : "");
    useEffect(() => {

    }, [])
    return (
        <>
            <div className={`dealers-block ${LoadingClass}`}>
                {dealersListPerPage.map(dealer => {
                    return (<DealerBlock
                        dealerName={dealer.Name}
                        dealerDistance={dealer.Distance}
                        dealerAddress={dealer.Address}
                        dealerInfo={dealer.Name}
                        dealerZipCode={dealer.ZipCode}
                        dealerCity={dealer.City}
                        key={dealer.DealerId}
                        dealerID={dealer.DealerId}
                        isOverDealer={dealer.IsHover}
                        dealerGeoID={dealer.GeoId}
                        dealerLCV={dealer.LCV}
                        dealerPC={dealer.PC}
                        dealerListeIdPremiumServices={dealer.ListeIdSP}
                        dealerCulture={dealer.Culture}
                        dealerPosition={{ lat: Number(dealer.Latitude), lng: Number(dealer.Longitude) }}
                        dealerSelfReception={dealer.SelfReception}
                        dealerIsClicked={dealer.isClicked}
                        isPCLCVFiltersActived={isPCLCVFiltersActived}
                    />)
                })}
                {!isLoading && <p className='showMoreButton' onClick={showMoreDealers}>{CONSTANTS.LABELS.multislots_display_more_dealers}</p>}
            </div>
        </>
    )
}

export default DealersList;